import React from 'react'
import Icon from 'blocks.simple/icon/icon'
import Button from 'blocks.simple/button/button'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import DropContent from 'blocks.simple/dropContent/dropContent'
import DisplaysInfoMethods, {
    GroupTreeItem,
    BuildInfo,
    ExternalStorageInfo,
    FormattedParameters,
    IDisplayInfoProps,
    ISelectedInfo,
    ISetMonitorWindow,
    IState,
    RefContent,
} from './displays__info.local.methods'
import { Scrollbars } from 'react-custom-scrollbars'
import ModalAccept from 'blocks.simple/modal/_accept/modal_accept'
import { appActions } from 'blocks.app/app/app.state'
import { cn } from 'ethcss'
import translate from 'core/translate'
import { colors, text as textStyles } from 'theme'
import { api } from 'core/api/ConnectionManager'
import grid from 'blocks.simple/grid/grid.jcss'
import toolbarContentStyles from '../__toolbarContent/displays__toolbarContent.jcss'
import styles from './displays__info.jcss'
import helpers from 'core/helpers'
import helpersDigitalSignages from 'core/helpers/_digitalSignages'
import template from 'es6-template-strings'
import { Typography } from 'atoms/Typography'
import { withRouter } from 'react-router'
import { displaysActions, getClientLogs } from '../displays.state'
import { connect } from 'react-redux'
import fileSize from 'filesize'
import moment from 'moment/moment'
import store, { AppDispatch } from 'core/store'
import displaysHelpers from '../../../core/helpers/_digitalSignages'
import DropMenu from '../../../blocks.simple/dropMenu/dropMenu'
import WakeOnLan from '../__wakeOnLan/wake__on__lan'
import Collapse from '../../../blocks.simple/collapse/collapse'
import { CountdownTimer } from '../../../blocks.simple/countdownTimer/ConutdownTimer'
import { changeLocation, routes } from 'features/routes'
import DisplaysUploadLogNotification from '../__uploadLogNotification/displays__uploadLogNotification'
import { toast } from 'react-toastify'

const noBroadcast = helpersDigitalSignages.getNoBroadcastIconSrc()

type CopyParameterValue = (value: string | number | boolean | null) => () => void

const getClientVersion = ({ newerClientVersion, id, status }: ISelectedInfo) => {
    if (newerClientVersion && (status === 'online' || status === 'error')) {
        return (
            <button className={styles.controlButton} onClick={() => api.send('updatePlayer', { digitalSignageId: id })}>
                <Icon
                    type="update_soft"
                    size={20}
                    color={colors.blackLight}
                    tooltip={{
                        title: translate('updateVersion'),
                    }}
                />
            </button>
        )
    }
}

const renderGroupedParameters = (
    selectedInfo: FormattedParameters,
    copyToClipboard: CopyParameterValue,
    status: string,
    state: IState,
    isOnline: boolean,
    getConnectionsSpeed: () => void,
    getStorageConnectionSpeed: () => void,
    activeQ: boolean,
    serviceRef: RefContent,
    deviceRef: RefContent,
    licensesRef: RefContent,
    networkRef: RefContent,
    storageRef: RefContent,
    toggleSingle: (value: boolean, name: string) => void,
    type: string,
    showConnectionError: () => void
) => {
    const serviceInfoGroup: React.ReactNode[] = []
    const deviceInfoGroup: React.ReactNode[] = []
    const licenseGroup: React.ReactNode[] = []
    const networkGroup: React.ReactNode[] = []
    const storageGeneralGroup: React.ReactNode[] = []
    const storageAppUsedGroup: React.ReactNode[] = []

    const serviceInfoKeys = [
        'id',
        'deviceId',
        'idCashRegisterGlobal',
        'dsVersion',
        'name',
        'description',
        'platform',
        'prettySysName',
        'applicationURL',
        'lastScreenshotDate',
        'lastScreenshot',
        'groupId',
        'companyId',
        'updatedAt',
        'createdAt',
        'tagTemplateString',
        'rootEnabled',
    ]

    const deviceInfoKeys = [
        'manufacturer',
        'modelName',
        'serialNumber',
        'osFamily',
        'osFamilyVersion',
        'firmwareVersion',
        'orientation',
        'resolutionWidth',
        'resolutionHeight',
        'volume',
    ]

    const networkKeys = [
        'ipAddress',
        'firstDns',
        'secondDns',
        'macAddress',
        'imei',
        'connectionType',
        'lastConnection',
        'networkIpMode',
        'networkWiFiSecurityMode',
        'networkWiFiEncryptionType',
        'networkWiFiSignalStrengthLevel',
        'networkGateway',
        'networkSubnetMask',
        'networkWiFiSsid',
        'serverToDsRequestTimeMS',
        'clientToServerResponseTimeMS',
        'clientToServerRequestTimeMS',
    ]

    const licenseKeys = ['licenseId', 'licenseType', 'rateType', 'licenseExpireDate', 'licensePurchaseDate']

    const storageGeneralKeys = ['storageSize', 'usedStorageSize', 'freeStorageSize', 'downloadFromStorageSpeed']
    const storageAppUsedKeys: Array<'usedBytes' | 'reservedBytes'> = ['usedBytes', 'reservedBytes']

    const renderParamLabel = (key: string) => (
        <span className={styles.paramLabelRow}>
            <span>{translate(key === 'platform' ? 'internalProductIdentifier' : key)}</span>
            {key === 'platform' ? <span className={styles.fieldHintBadge}>{translate('formerlyPlatform')}</span> : null}
            {key === 'osFamily' || key === 'osFamilyVersion' ? (
                <span className={styles.fieldHintBadge}>{translate('fromPlatform')}</span>
            ) : null}
        </span>
    )

    const renderParamRow = (key: string, value: React.ReactNode) => (
        <div key={key} className={cn(styles.paramsItem, key === 'platform' && styles.paramsItemTop)}>
            <Typography type="title" className={cn(grid.w45, styles.displayParameterName)}>
                {renderParamLabel(key)}
            </Typography>
            <Typography type="title" className={styles.displayInfoParameterValue}>
                {value}
                {key === 'platform' ? (
                    <div className={styles.fieldDescription}>{translate('platformProductIdDescription')}</div>
                ) : null}
            </Typography>
        </div>
    )

    const getParamValue = (key: string) => selectedInfo[key]

    const pushIfValue = (group: React.ReactNode[], key: string, valueNode: React.ReactNode) => {
        const paramValue = getParamValue(key)
        if (paramValue === null || paramValue === undefined || paramValue === '') {
            return
        }
        group.push(renderParamRow(key, valueNode))
    }

    serviceInfoKeys.forEach((key) => {
        const paramValue = getParamValue(key)
        pushIfValue(
            serviceInfoGroup,
            key,
            key === 'rootEnabled' ? (
                <div
                    onClick={copyToClipboard(paramValue)}
                    dangerouslySetInnerHTML={{
                        __html: paramValue,
                    }}
                    className={styles.wikiLink}
                />
            ) : key === 'applicationURL' || key === 'lastScreenshot' ? (
                <a
                    className={styles.paramLink}
                    href={paramValue}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    <span onClick={copyToClipboard(paramValue)}>{paramValue}</span>
                </a>
            ) : (
                <span onClick={copyToClipboard(paramValue)}>{paramValue}</span>
            )
        )
    })

    deviceInfoKeys.forEach((key) => {
        const paramValue = getParamValue(key)
        pushIfValue(deviceInfoGroup, key, <span onClick={copyToClipboard(paramValue)}>{paramValue}</span>)
    })

    licenseKeys.forEach((key) => {
        const paramValue = getParamValue(key)
        pushIfValue(
            licenseGroup,
            key,
            <span onClick={copyToClipboard(paramValue)}>
                {key === 'licensePurchaseDate' || key === 'licenseExpireDate'
                    ? paramValue
                        ? moment(paramValue).format('DD.MM.YYYY')
                        : ''
                    : paramValue}
            </span>
        )
    })

    networkKeys.forEach((key) => {
        const paramValue = getParamValue(key)
        pushIfValue(networkGroup, key, <span onClick={copyToClipboard(paramValue)}>{paramValue}</span>)
    })

    storageGeneralKeys.forEach((key) => {
        const paramValue = getParamValue(key)
        pushIfValue(storageGeneralGroup, key, <span onClick={copyToClipboard(paramValue)}>{paramValue}</span>)
    })

    const appUsedStorageInfo = state.storageInfo?.storageInfo?.appUsedStorageInfo
    if (appUsedStorageInfo) {
        storageAppUsedKeys.forEach((key) => {
            const storageValue = appUsedStorageInfo[key]
            if (storageValue === null || storageValue === undefined) {
                return
            }

            storageAppUsedGroup.push(
                renderParamRow(key, <span onClick={copyToClipboard(storageValue)}>{fileSize(storageValue)}</span>)
            )
        })
    }

    return (
        <>
            {serviceInfoGroup.length ? (
                <Collapse
                    className={cn(styles.collapseCard, 'test-device-info-block')}
                    contentWrapperClassName={styles.collapseContent}
                    onToggle={(value) => toggleSingle(value, 'mainRef')}
                    title={() => ''}
                    titleAsBlock={() => (
                        <div className={`${styles.groupHeader}`}>
                            <div className={styles.groupHeaderItem}>
                                <Icon type={type === 'group' ? 'folderWithLines' : 'book'} size={20} />
                                <div className={styles.headerCaption}>
                                    {translate(type === 'group' ? 'generalGroupInfo' : 'serviceInfo')}
                                </div>
                            </div>
                        </div>
                    )}
                    refObj={serviceRef}
                >
                    <div className={styles.groupList} style={{ width: '100%' }}>
                        {serviceInfoGroup.map((element) => element)}
                    </div>
                </Collapse>
            ) : null}
            {type !== 'group' && deviceInfoGroup.length ? (
                <Collapse
                    className={cn(styles.collapseCard, 'test-device-info-block')}
                    contentWrapperClassName={styles.collapseContent}
                    onToggle={(value) => toggleSingle(value, 'deviceRef')}
                    title={() => ''}
                    titleAsBlock={() => (
                        <div className={`${styles.groupHeader}`}>
                            <div className={styles.groupHeaderItem}>
                                <Icon type="monitor" size={20} />
                                <div className={styles.headerCaption}>{translate('device')}</div>
                            </div>
                        </div>
                    )}
                    refObj={deviceRef}
                >
                    <div className={styles.groupList} style={{ width: '100%' }}>
                        {deviceInfoGroup.map((element) => element)}
                    </div>
                </Collapse>
            ) : null}
            {activeQ && licenseGroup.length ? (
                <Collapse
                    className={cn(styles.collapseCard, 'test-device-info-block')}
                    contentWrapperClassName={styles.collapseContent}
                    onToggle={(value) => toggleSingle(value, 'licensesRef')}
                    title={() => ''}
                    titleAsBlock={() => (
                        <div className={`${styles.groupHeader}`}>
                            <div className={styles.groupHeaderItem}>
                                <Icon type="licenses" size={22} />
                                <div className={styles.headerCaption}>{translate('license1')}</div>
                            </div>
                        </div>
                    )}
                    refObj={licensesRef}
                >
                    <div className={styles.groupList} style={{ width: '100%' }}>
                        {licenseGroup.map((element) => element)}
                    </div>
                </Collapse>
            ) : null}
            {networkGroup.length || (state.networkInfoLoading && isOnline) ? (
                <Collapse
                    className={cn(styles.collapseCard, 'test-device-info-block')}
                    contentWrapperClassName={styles.collapseContent}
                    onToggle={(value) => toggleSingle(value, 'networkRef')}
                    showArrow={!(state.networkInfoLoading && isOnline)}
                    title={() => ''}
                    titleAsBlock={() => (
                        <>
                            <div className={`${styles.groupHeader}`}>
                                <div className={styles.groupHeaderItem}>
                                    <Icon type="network" size={22} />
                                    <div className={styles.headerCaption}>{translate('connection')}</div>
                                </div>
                            </div>
                            {state.networkInfoLoading && isOnline ? (
                                <div className={styles.sectionLoaderSpinner} />
                            ) : null}
                        </>
                    )}
                    refObj={networkRef}
                >
                    <div className={styles.groupList} style={{ width: '100%' }}>
                        <div className={styles.headerActive} onClick={getConnectionsSpeed}>
                            {translate('connectionCheck')}
                        </div>
                        {state.isConnectionSpeedLoading && (
                            <div className={state.connectionError ? styles.subHeaderError : styles.subHeader}>
                                <>
                                    {state.connectionError ? (
                                        <div>{translate('deviceIsUnavailable')}</div>
                                    ) : (
                                        <div className={styles.loadingConnectionRow}>
                                            <div className={styles.sectionLoaderSpinnerSm} />
                                            <span>
                                                {translate('loadingConnection')}
                                                <span className={styles.countdown}>
                                                    <CountdownTimer
                                                        time={window.spconfig.dsConnectionTestTimeout}
                                                        onCountdownEnd={showConnectionError}
                                                    />
                                                </span>
                                            </span>
                                        </div>
                                    )}
                                </>
                            </div>
                        )}
                        {networkGroup.map((element) => element)}
                    </div>
                </Collapse>
            ) : null}
            {storageGeneralGroup.length || (state.storageInfoLoading && isOnline) ? (
                <Collapse
                    className={cn(styles.collapseCard, 'test-device-info-block')}
                    contentWrapperClassName={styles.collapseContent}
                    onToggle={(value) => toggleSingle(value, 'storageRef')}
                    showArrow={!(state.storageInfoLoading && isOnline)}
                    title={() => ''}
                    titleAsBlock={() => (
                        <>
                            <div className={`${styles.groupHeader}`}>
                                <div className={styles.groupHeaderItem}>
                                    <Icon type="internal_storage" size={18} />
                                    <div className={styles.headerCaption}>{translate('internalStorage')}</div>
                                </div>
                            </div>
                            {state.storageInfoLoading && isOnline ? (
                                <div className={styles.sectionLoaderSpinner} />
                            ) : null}
                        </>
                    )}
                    refObj={storageRef}
                >
                    <div className={styles.groupList} style={{ width: '100%' }}>
                        {helpersDigitalSignages.isStorageDownloadSpeedAvailable(selectedInfo?.platform) && (
                            <div className={styles.headerActive} onClick={getStorageConnectionSpeed}>
                                {translate('connectionCheck')}
                            </div>
                        )}
                        {storageAppUsedGroup.length > 0 && (
                            <div className={styles.subHeader}>{translate('appUsedStorage')}</div>
                        )}
                        {state.isStorageConnectionSpeedLoading && (
                            <div className={styles.subHeader}>
                                <div className={styles.loadingConnectionRow}>
                                    <div className={styles.sectionLoaderSpinnerSm} />
                                    <span>{translate('loadingConnection')}</span>
                                </div>
                            </div>
                        )}
                        {state.hasStorageConnectionSpeedError && (
                            <div className={styles.subHeaderError}>{translate('storageConnectionError')}</div>
                        )}
                        {storageAppUsedGroup.map((element) => element)}
                        {storageGeneralGroup.length > 0 && (
                            <div className={styles.subHeader}>{translate('generalStorage')}</div>
                        )}
                        {storageGeneralGroup.map((element) => element)}
                    </div>
                </Collapse>
            ) : null}
        </>
    )
}

const renderExternalStorageInfo = (
    data: ExternalStorageInfo | null,
    status: string,
    copyToClipboard: CopyParameterValue,
    externalStorageRef: RefContent,
    toggleSingle: (value: boolean, name: string) => void
) => {
    if (!data) return null
    if (!data.externalStorages) return null

    return data.externalStorages.map((storage, index) => {
        return (
            <Collapse
                className={styles.collapseCard}
                contentWrapperClassName={styles.collapseContent}
                onToggle={(value) => toggleSingle && toggleSingle(value, 'externalStorageRef')}
                title={() => ''}
                titleAsBlock={() => (
                    <div className={`${styles.groupHeader}`}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Icon type="storage" size={18} />
                            <div className={styles.headerCaption}>
                                {translate('externalStorage')}
                                {storage.label ? (
                                    <span className={styles.headerCaptionAccent}> • {storage.label}</span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}
                refObj={externalStorageRef}
            >
                <div className={styles.groupList} style={{ width: '100%' }}>
                    <div className={styles.paramsItem}>
                        <Typography type="title" className={cn(grid.w45)}>
                            {translate('storageSize')}
                        </Typography>
                        <Typography type="title" className={styles.displayInfoParameterValue}>
                            <span onClick={copyToClipboard(fileSize(storage.size.totalBytes))}>
                                {fileSize(storage.size.totalBytes)}
                            </span>
                        </Typography>
                    </div>
                    <div className={styles.paramsItem}>
                        <Typography type="title" className={cn(grid.w45)}>
                            {translate('usedStorageSize')}
                        </Typography>
                        <Typography type="title" className={styles.displayInfoParameterValue}>
                            <span onClick={copyToClipboard(fileSize(storage.size.usedBytes))}>
                                {fileSize(storage.size.usedBytes)}
                            </span>
                        </Typography>
                    </div>
                    <div className={styles.paramsItem}>
                        <Typography type="title" className={cn(grid.w45)}>
                            {translate('freeStorageSize')}
                        </Typography>
                        <Typography type="title" className={styles.displayInfoParameterValue}>
                            <span onClick={copyToClipboard(fileSize(storage.size.availableBytes))}>
                                {fileSize(storage.size.availableBytes)}
                            </span>
                        </Typography>
                    </div>
                    <div className={styles.paramsItem}>
                        <Typography type="title" className={cn(grid.w45)}>
                            {translate('updatedAt')}
                        </Typography>
                        <Typography type="title" className={styles.displayInfoParameterValue}>
                            <span
                                onClick={copyToClipboard(
                                    moment(data.externalStoragesUpdatedAt).format('DD/MM/YYYY HH:mm:ss')
                                )}
                            >
                                {moment(data.externalStoragesUpdatedAt).format('DD/MM/YYYY HH:mm:ss')}
                            </span>
                        </Typography>
                    </div>
                </div>
            </Collapse>
        )
    })
}

const getBuildInfo = (
    data: BuildInfo | null,
    status: string,
    copyToClipboard: CopyParameterValue,
    showMore: boolean,
    setShowMore: () => void,
    buildRef: RefContent,
    toggleSingle: (value: boolean, name: string) => void
) => {
    if (!data) return null

    const rawData = []

    for (let key in data) {
        if (key !== 'buildType' && key !== 'buildDatetime' && key !== 'buildHash') {
            rawData.push({ name: key, value: data[key] })
        }
    }

    return (
        <Collapse
            className={styles.collapseCard}
            contentWrapperClassName={styles.collapseContent}
            onToggle={(value) => toggleSingle(value, 'buildRef')}
            title={() => ''}
            titleAsBlock={() => (
                <div className={`${styles.groupHeader}`}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Icon type="info" size={18} />
                        <div className={styles.headerCaption}>{translate('buildParams')}</div>
                    </div>
                </div>
            )}
            refObj={buildRef}
        >
            <div className={styles.groupList} style={{ width: '100%' }}>
                <div className={styles.paramsItem}>
                    <Typography type="title" className={cn(grid.w45, styles.paramsItemTextOverflow)}>
                        {translate('buildType')}
                    </Typography>
                    <Typography type="title" className={styles.displayInfoParameterValue}>
                        <span onClick={copyToClipboard(data.buildType)}>{data.buildType}</span>
                    </Typography>
                </div>
                <div className={styles.paramsItem}>
                    <Typography type="title" className={cn(grid.w45, styles.paramsItemTextOverflow)}>
                        {translate('buildDatetime')}
                    </Typography>
                    <Typography type="title" className={styles.displayInfoParameterValue}>
                        <span onClick={copyToClipboard(data.buildDatetime)}>{data.buildDatetime}</span>
                    </Typography>
                </div>
                <div className={styles.paramsItem}>
                    <Typography type="title" className={cn(grid.w45, styles.paramsItemTextOverflow)}>
                        {translate('buildHash')}
                    </Typography>
                    <Typography type="title" className={styles.displayInfoParameterValue}>
                        <span onClick={copyToClipboard(data.buildHash)}>{data.buildHash}</span>
                    </Typography>
                </div>
                {rawData.length ? (
                    <div>
                        {!showMore && (
                            <div className={styles.showMore} onClick={setShowMore}>
                                {translate('moreDetails')}
                            </div>
                        )}
                        {showMore &&
                            rawData.map((data) => {
                                return (
                                    <div className={styles.paramsItem}>
                                        <Typography
                                            type="title"
                                            className={cn(grid.w45, styles.paramsItemTextOverflow)}
                                        >
                                            {translate(data.name)}
                                        </Typography>
                                        <Typography type="title" className={styles.displayInfoParameterValue}>
                                            <span onClick={copyToClipboard(data.value)}>{data.value}</span>
                                        </Typography>
                                    </div>
                                )
                            })}
                    </div>
                ) : null}
            </div>
        </Collapse>
    )
}

const getLogLevel = (p_: IDisplayInfoProps) => {
    const item = p_.selectedInfo

    if (!item || item.type === 'group') return null

    const logLevel = item.settings.logLevel

    return (
        <div className={styles.logLevelInfo}>
            {logLevel === 'Off' ? (
                <>
                    {translate('logLevelIsOff')}
                    <b className={styles.goToSettings} onClick={() => goToDeviceSettings(p_)}>
                        {translate('inDeviceSettings')}
                    </b>
                </>
            ) : (
                <>
                    {translate('currentLogLevel')}:{' '}
                    <b className={styles.logLevelValue} onClick={() => goToDeviceSettings(p_)}>
                        {logLevel}
                    </b>
                </>
            )}
        </div>
    )
}

const renderGroupTreeInfo = (
    selectedInfo: ISelectedInfo,
    data: GroupTreeItem[],
    copyToClipboard: CopyParameterValue,
    groupTreeRef: RefContent,
    toggleSingle: (value: boolean, name: string) => void,
    groupsOpened: { id: number; parentId: number }[],
    onToggleGroup: ({ id, parentId }: { id: number; parentId: number }) => void
) => {
    const getMarginLeft = (nestedLevel: number) => {
        return {
            paddingLeft: 28 + 14 * nestedLevel,
            left: 8 + 14 * nestedLevel,
        }
    }

    const renderChildren = (groups: GroupTreeItem[], isVisible: boolean): React.ReactNode[] => {
        return groups.map((group) => {
            const isOpened =
                !!group.children.length &&
                groupsOpened.some((item) => group.id === item.id) &&
                groupsOpened.some((item) => group.parentId === item.id || item.parentId === selectedInfo.id)

            return (
                <>
                    <tr
                        className={styles.groupTreeRow}
                        style={{
                            display: isVisible ? 'table-row' : 'none',
                        }}
                    >
                        <td
                            className={cn(styles.groupTreeCol, styles.groupTreeColName)}
                            style={{
                                paddingLeft: getMarginLeft(group.nestedLevel).paddingLeft,
                            }}
                        >
                            {!!group.children.length ? (
                                <Icon
                                    type={isOpened ? 'arrow_down' : 'arrow_right'}
                                    size={12}
                                    onClick={() => {
                                        onToggleGroup({ id: group.id, parentId: group.parentId })
                                    }}
                                    containerClass={styles.toggleGroupButton}
                                    wrapperStyle={{ left: getMarginLeft(group.nestedLevel).left }}
                                />
                            ) : (
                                <span className={styles.dot} style={{ left: getMarginLeft(group.nestedLevel).left }}>
                                    &#8226;
                                </span>
                            )}
                            {group.name}
                        </td>
                        <td className={styles.groupTreeCol}>{group.digitalSignageCount}</td>
                    </tr>
                    {group.children.length ? renderChildren(group.children, isOpened) : null}
                </>
            )
        })
    }

    return (
        <Collapse
            className={styles.collapseCard}
            contentWrapperClassName={styles.collapseContent}
            onToggle={(value) => toggleSingle(value, 'buildRef')}
            title={() => ''}
            titleAsBlock={() => (
                <div className={`${styles.groupHeader}`}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Icon type="folderGroup" size={22} />
                        <div className={styles.headerCaption}>{translate('dsAndGroupsInfo')}</div>
                    </div>
                </div>
            )}
            refObj={groupTreeRef}
        >
            <div className={styles.groupList} style={{ width: '100%' }}>
                <table className={styles.groupTreeTable}>
                    <tbody>
                        <tr className={styles.groupTreeRow}>
                            <th className={styles.groupTreeCol}>Подгруппы</th>
                            <th className={styles.groupTreeCol}>Устройства</th>
                        </tr>
                        {data && renderChildren(data, true)}
                    </tbody>
                </table>
            </div>
        </Collapse>
    )
}

const waitForDownload = () => {
    return <div className={styles.waitForDownload}>{translate('waitForDownload')}</div>
}

const goToDeviceSettings = (p_: IDisplayInfoProps) => {
    p_.closeModal()
    store.dispatch(displaysActions.openModal({ modalState: 'displaySettings', modalOptions: {} }))
}

const renderControlButton = (
    iconName: string,
    onClick: React.MouseEventHandler<HTMLButtonElement>,
    tooltip: string
) => {
    return (
        <button className={styles.controlButton} onClick={onClick}>
            <Icon
                type={iconName}
                size={18}
                tooltip={{
                    title: tooltip,
                }}
                color={colors.blackLight}
            />
        </button>
    )
}

const DisplaysInfo = (p_: IDisplayInfoProps) => {
    const {
        state,
        setState,
        screenRef,
        mainRef: serviceRef,
        deviceRef,
        licensesRef,
        networkRef,
        storageRef,
        externalStorageRef,
        buildRef,
        groupTreeRef,
        screenHeight,
        enableRefreshAnimation,
        toggleLoadLogsMenu,
        checkPowerButtonDisableStatus,
        isOfflineStatus,
        isOnlineStatus,
        isErrorStatus,
        isSleepStatus,
        exitSleepMode,
        isMonitoringSupport,
        softResetIsSupported,
        openSoftResetModal,
        isWebEngineInfoSupport,
        closeSoftResetModal,
        softReset,
        getDsStateLabel,
        getDsStateFormat,
        copyParametersToClipboard,
        getDsStorageInfo,
        getExternalStorageInfo,
        getNetworkInfo,
        copyParameterValueToClipboard,
        getConnectionsSpeed,
        getStorageConnectionSpeed,
        toggleSingle,
        showConnectionError,
        setShowMore,
        closeWebEngineInfo,
        enterSleepMode,
        onToggleGroup,
        toggleCleanMenu,
        toggleAll,
    } = DisplaysInfoMethods(p_)

    const onUploadLogTaskCreated = () => {
        toast.info(<DisplaysUploadLogNotification />, {
            hideProgressBar: true,
            position: 'bottom-left',
        })
    }

    const s_ = state
    const availableCommands = helpersDigitalSignages.getAvailableCommands(p_.selectedInfo)
    const isOnline = p_.selectedInfo.online && p_.selectedInfo.status !== 'sleep'
    const isAllFieldsExpanded = Object.values(s_.toggleStatusList).every(Boolean)

    const orientationWidth = () => {
        return p_.selectedInfo &&
            p_.selectedInfo.settings &&
            p_.selectedInfo.settings.autoScreenshot &&
            p_.selectedInfo.settings.autoScreenshot.width
            ? p_.selectedInfo.settings.autoScreenshot.width
            : p_.selectedInfo.resolutionWidth && p_.selectedInfo.resolutionWidth
    }

    const orientationHeight = () => {
        return p_.selectedInfo &&
            p_.selectedInfo.settings &&
            p_.selectedInfo.settings.autoScreenshot &&
            p_.selectedInfo.settings.autoScreenshot.height
            ? p_.selectedInfo.settings.autoScreenshot.height
            : p_.selectedInfo.resolutionHeight
    }

    return (
        <Scrollbars style={{ width: '100%', height: '100%' }}>
            <div className={cn(grid.full, styles.mainWrapper)}>
                <div className={styles.wrapperContainer}>
                    <div className={styles.backButton} onClick={p_.closeModal}>
                        <Icon type={'backArrow'} size={20} /> <span>{translate('back')}</span>
                    </div>
                    <div className={styles.title}>
                        <b>
                            {translate(
                                p_.selectedInfo && p_.selectedInfo.type === 'digitalSignage'
                                    ? 'deviceInfo'
                                    : 'groupInformation'
                            )}
                        </b>
                        <span className={styles.titleSeparator}> • </span>
                        <span className={styles.titleName}>{p_.selectedInfo.name}</span>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.leftBlock}>
                            <div className={styles.screenshotWrapper}>
                                <div
                                    className={styles.screenshot}
                                    ref={screenRef}
                                    style={{
                                        backgroundImage: `url(${
                                            p_.selectedInfo.cover ? p_.selectedInfo.cover[0] : noBroadcast
                                        })`,
                                        backgroundPosition: p_.selectedInfo.cover ? 'center center' : 'unset',
                                        backgroundSize: !!p_.selectedInfo.cover ? 'contain' : 'auto',
                                        backgroundRepeat: 'no-repeat',
                                        height: screenHeight + 'px',
                                    }}
                                >
                                    <div className={styles.screenshotInner}>
                                        <div className={cn(styles.statusName, styles[p_.selectedInfo.status])}>
                                            {p_.selectedInfo &&
                                                p_.selectedInfo.type !== 'group' &&
                                                translate(p_.selectedInfo.status)}
                                        </div>
                                        <div className={`${styles.iconUpdate}`}>
                                            {helpers.isAvailableAction(p_.selectedInfo, {
                                                key: 'digitalSignage',
                                                action: 'update',
                                                subaction: 'updateScreenshot',
                                            }) && (
                                                <Icon
                                                    type="update_tiny"
                                                    size={18}
                                                    tooltip={{
                                                        title: translate('updateScreen'),
                                                    }}
                                                    className={s_.isUpdatingScreenShot ? styles.iconUpdateAnim : ''}
                                                    disabled={
                                                        p_.selectedInfo.status === 'offline' ||
                                                        p_.selectedInfo.status === 'sleep'
                                                    }
                                                    onClick={() => {
                                                        enableRefreshAnimation()
                                                        api.send('updateScreenshotCb', {
                                                            [p_.selectedInfo.type === 'group' ? 'groupId' : 'id']: p_
                                                                .selectedInfo.id,
                                                            width: orientationWidth(),
                                                            height: orientationHeight(),
                                                        })
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {p_.isConnected ? waitForDownload() : getLogLevel(p_)}
                                <div className={styles.dsControlPanel}>
                                    {helpers.isAvailableAction(p_.selectedInfo, {
                                        key: 'digitalSignage',
                                        action: 'update',
                                        subaction: 'downloadLogs',
                                    }) &&
                                        p_.selectedInfo.status !== 'offline' &&
                                        p_.selectedInfo.status !== 'sleep' && (
                                            <div>
                                                {p_.selectedInfo.type !== 'group' && isOnline && (
                                                    <>
                                                        <DropContent
                                                            isOpen={s_.getClientLogsMenu}
                                                            position="bottom center"
                                                            iconColor="white"
                                                            indents="none"
                                                            wrapperClassName={styles.dropContent}
                                                            onClickOutside={() =>
                                                                setState((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        getClientLogsMenu: false,
                                                                    }
                                                                })
                                                            }
                                                            customContent={
                                                                <div>
                                                                    <div
                                                                        className={
                                                                            toolbarContentStyles.removeGroupButton
                                                                        }
                                                                        onClick={() => {
                                                                            api.send('createUploadLogTask', {
                                                                                ids: [p_.selectedInfo.id],
                                                                                groupIds: [],
                                                                                actual: true,
                                                                            }).then(() => {
                                                                                onUploadLogTaskCreated()
                                                                            })
                                                                            setState((prevState) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    getClientLogsMenu: false,
                                                                                }
                                                                            })
                                                                        }}
                                                                    >
                                                                        {translate('actual_logs')}
                                                                    </div>
                                                                    <div
                                                                        className={toolbarContentStyles.removeAll}
                                                                        onClick={() => {
                                                                            api.send('createUploadLogTask', {
                                                                                ids: [p_.selectedInfo.id],
                                                                                groupIds: [],
                                                                                actual: false,
                                                                            }).then(() => {
                                                                                onUploadLogTaskCreated()
                                                                            })
                                                                            setState((prevState) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    getClientLogsMenu: false,
                                                                                }
                                                                            })
                                                                        }}
                                                                    >
                                                                        {translate('full_logs')}
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <button
                                                                className={styles.controlButton}
                                                                onClick={toggleLoadLogsMenu}
                                                            >
                                                                <Icon
                                                                    type={'download'}
                                                                    size={18}
                                                                    tooltip={{
                                                                        title: p_.isConnected
                                                                            ? translate('downloadMedia')
                                                                            : translate('deviceLog'),
                                                                    }}
                                                                />
                                                            </button>
                                                        </DropContent>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    {helpers.isAvailableAction(p_.selectedInfo, {
                                        key: 'digitalSignage',
                                        action: 'update',
                                        subaction: 'shutdown',
                                    }) && (
                                        <DropMenu
                                            active={s_.active}
                                            onChange={(active) =>
                                                setState((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        active,
                                                    }
                                                })
                                            }
                                            mod="centered"
                                            wrapperClassName={styles.powerControls}
                                            firstItemClassname={styles.powerBtn}
                                            contentClassName={styles.contentClassName}
                                            isDisplayInfo={true}
                                            items={[
                                                {
                                                    id: 'power',
                                                    show: helpers.isAvailableAction(p_.selectedInfo, {
                                                        key: 'digitalSignage',
                                                        action: 'update',
                                                        subaction: 'shutdown',
                                                    }),
                                                    icon: 'power',
                                                    color: colors.blackLight,
                                                    size: 18,
                                                    tooltip: {
                                                        title: translate('power'),
                                                    },
                                                    disabled: checkPowerButtonDisableStatus(p_.selectedInfo),
                                                    children: (
                                                        <div className={styles.deleteGroup}>
                                                            {!isOfflineStatus(p_.selectedInfo) ? (
                                                                <>
                                                                    {(isOnlineStatus(p_.selectedInfo) ||
                                                                        isErrorStatus(p_.selectedInfo)) &&
                                                                    availableCommands.includes('shutdown') ? (
                                                                        <>
                                                                            <div
                                                                                className={styles.menuItem}
                                                                                onClick={() => {
                                                                                    setState((prevState) => {
                                                                                        return {
                                                                                            ...prevState,
                                                                                            openPowerModal: 'id',
                                                                                            active: [],
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            >
                                                                                {translate('switchOff')}
                                                                            </div>
                                                                            <div
                                                                                className={styles.menuItem}
                                                                                onClick={() => {
                                                                                    setState((prevState) => {
                                                                                        return {
                                                                                            ...prevState,
                                                                                            sleepModeModal:
                                                                                                p_.selectedInfo.type ===
                                                                                                'group'
                                                                                                    ? 'groupId'
                                                                                                    : 'digitalSignageId',
                                                                                            active: [],
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            >
                                                                                {translate('sleep')}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {isSleepStatus(p_.selectedInfo) && (
                                                                                <div
                                                                                    className={styles.menuItem}
                                                                                    onClick={() => {
                                                                                        exitSleepMode({
                                                                                            digitalSignageId:
                                                                                                p_.selectedInfo.id,
                                                                                        })
                                                                                    }}
                                                                                >
                                                                                    {translate('exitSleepMode')}
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {displaysHelpers.availableWakeOnLan(
                                                                        p_.selectedInfo.platform
                                                                    ) && (
                                                                        <div
                                                                            className={styles.menuItem}
                                                                            onClick={() => {
                                                                                setState((prevState) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        wakeOnLanModal: true,
                                                                                        active: [],
                                                                                    }
                                                                                })
                                                                            }}
                                                                        >
                                                                            {translate('enableDevice')}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    id: 'restart',
                                                    show: helpers.isAvailableAction(p_.selectedInfo, {
                                                        key: 'digitalSignage',
                                                        action: 'update',
                                                        subaction: 'shutdown',
                                                    }),
                                                    icon: 'restart',
                                                    size: 18,
                                                    tooltip: {
                                                        title: translate('restart'),
                                                    },
                                                    disabled:
                                                        !isOnlineStatus(p_.selectedInfo) &&
                                                        !isErrorStatus(p_.selectedInfo),
                                                    children: (
                                                        <>
                                                            {availableCommands.includes('reboot') && (
                                                                <div
                                                                    className={styles.menuItem}
                                                                    onClick={() => {
                                                                        api.send('rebootDisplay', {
                                                                            id: p_.selectedInfo.id,
                                                                        })
                                                                        setState((prevState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                active: [],
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    {translate('reboot_device')}
                                                                </div>
                                                            )}
                                                            {availableCommands.includes('restartApp') && (
                                                                <div
                                                                    className={styles.menuItem}
                                                                    onClick={() => {
                                                                        api.send('digitalSignageSendRestartApp', {
                                                                            id: p_.selectedInfo.id,
                                                                        })
                                                                        setState((prevState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                active: [],
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    {translate('restart_application')}
                                                                </div>
                                                            )}
                                                        </>
                                                    ),
                                                },
                                            ]}
                                        />
                                    )}
                                    {helpers.isAvailableAction(p_.selectedInfo, {
                                        key: 'digitalSignage',
                                        action: 'update',
                                    }) && getClientVersion(p_.selectedInfo)}
                                    {helpers.isAvailableAction(p_.selectedInfo, {
                                        key: 'digitalSignage',
                                        action: 'update',
                                        subaction: 'clearDeviceStorage',
                                    }) &&
                                        isOnline && (
                                            <DropContent
                                                isOpen={s_.showCleanMenu}
                                                position="bottom left"
                                                iconColor="white"
                                                indents="none"
                                                className_={styles.clearInfoClass}
                                                onClickOutside={() =>
                                                    setState((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            showCleanMenu: false,
                                                        }
                                                    })
                                                }
                                                wrapperClassName={styles.dropContent}
                                                customContent={
                                                    <div className={cn(grid.p_md, textStyles.left)}>
                                                        <Typography type="title" className={cn(grid.mb_micro)}>
                                                            {translate('chooseTypeClear')}:
                                                        </Typography>
                                                        <Typography
                                                            type="text"
                                                            className={cn(textStyles.mini, grid.mb_md)}
                                                        >
                                                            {translate('deviceWillBeReboot')}
                                                        </Typography>
                                                        <Checkbox
                                                            checked={s_.clean.files}
                                                            className={cn(grid.pb_mini)}
                                                            label={translate('removeAllFilesAtDevice')}
                                                            onClick={() =>
                                                                setState((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        clean: {
                                                                            ...s_.clean,
                                                                            files: !s_.clean.files,
                                                                        },
                                                                    }
                                                                })
                                                            }
                                                        />
                                                        <Checkbox
                                                            label={translate('clearLocalStorage')}
                                                            className={cn(grid.pb_mini)}
                                                            checked={s_.clean.database}
                                                            onClick={() =>
                                                                setState((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        clean: {
                                                                            ...s_.clean,
                                                                            database: !s_.clean.database,
                                                                        },
                                                                    }
                                                                })
                                                            }
                                                        />
                                                        <Checkbox
                                                            label={translate('clearStatistic')}
                                                            checked={s_.clean.statistic}
                                                            className={cn(grid.pb_mini)}
                                                            onClick={() =>
                                                                setState((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        clean: {
                                                                            ...s_.clean,
                                                                            statistic: !s_.clean.statistic,
                                                                        },
                                                                    }
                                                                })
                                                            }
                                                        />
                                                        <Checkbox
                                                            label={translate('clearDsLogs')}
                                                            checked={s_.clean.logs}
                                                            onClick={() =>
                                                                setState((prevState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        clean: {
                                                                            ...s_.clean,
                                                                            logs: !s_.clean.logs,
                                                                        },
                                                                    }
                                                                })
                                                            }
                                                        />
                                                        <div className={cn(grid.row, grid.justify, grid.mt_md)}>
                                                            <div />
                                                            <div className={grid.row}>
                                                                <Button
                                                                    className={cn(grid.mr_mini)}
                                                                    onClick={() => {
                                                                        setState((prevState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                showCleanMenu: false,
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    {translate('cancel')}
                                                                </Button>
                                                                <Button
                                                                    mod={'fill'}
                                                                    onClick={() => {
                                                                        if (s_.clean && s_.clean.logs) {
                                                                            setState((prevState) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    showClearLogsWarning: true,
                                                                                    showCleanMenu: false,
                                                                                }
                                                                            })

                                                                            return
                                                                        }

                                                                        api.send('clearDigitalSignageDiskSpace', {
                                                                            digitalSignageId: p_.selectedInfo.id,
                                                                            ...s_.clean,
                                                                        })
                                                                        setState((prevState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                showCleanMenu: false,
                                                                            }
                                                                        })
                                                                    }}
                                                                    disabled={
                                                                        !s_.clean.files &&
                                                                        !s_.clean.database &&
                                                                        !s_.clean.statistic &&
                                                                        !s_.clean.logs
                                                                    }
                                                                >
                                                                    {translate('clean')}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            >
                                                <button className={styles.controlButton} onClick={toggleCleanMenu}>
                                                    <Icon
                                                        type={'clean'}
                                                        size={18}
                                                        color={colors.blackLight}
                                                        tooltip={{
                                                            title: translate('clean'),
                                                        }}
                                                    />
                                                </button>
                                            </DropContent>
                                        )}
                                    {p_.selectedInfo.type !== 'group' &&
                                        isOnline &&
                                        isMonitoringSupport(p_.selectedInfo.platform) &&
                                        renderControlButton(
                                            'monitoring',
                                            () => {
                                                p_.setMonitorWindow({
                                                    title: p_.selectedInfo.name,
                                                    type: 'digitalSignageLogMonitor',
                                                    options: {
                                                        name: p_.selectedInfo.name,
                                                        digitalSignageId: p_.selectedInfo.id,
                                                        status: p_.selectedInfo.status,
                                                    },
                                                })
                                            },
                                            translate('monitoring')
                                        )}
                                    {p_.selectedInfo.type !== 'group' &&
                                        isOnline &&
                                        softResetIsSupported(p_.selectedInfo.platform) &&
                                        isMonitoringSupport(p_.selectedInfo.platform) &&
                                        renderControlButton(
                                            'displayWithGear',
                                            openSoftResetModal,
                                            translate('softReset')
                                        )}
                                    {p_.selectedInfo.type !== 'group' &&
                                        isOnline &&
                                        isWebEngineInfoSupport(p_.selectedInfo.platform) &&
                                        renderControlButton(
                                            'webEngineInfo',
                                            () => {
                                                api.send('webEngineInfo', { id: p_.selectedInfo.id })
                                            },
                                            translate('webEngineInfo')
                                        )}
                                </div>
                                {s_.softResetModal && (
                                    <div className={styles.softResetModal}>
                                        <div className={styles.softResetModalInner}>
                                            <div className={styles.softResetModalCaption}>
                                                {translate('softResetConfirm')}
                                            </div>
                                            <div className={styles.softResetModalButtons}>
                                                <Button
                                                    mod={'withBorder'}
                                                    rounded="full_md"
                                                    indentSize="mini"
                                                    onClick={closeSoftResetModal}
                                                    className={styles.softResetModalButton}
                                                >
                                                    {translate('cancel')}
                                                </Button>
                                                <Button
                                                    rounded="full_md"
                                                    indentSize="mini"
                                                    mod="fill"
                                                    onClick={softReset}
                                                    className={styles.softResetModalButton}
                                                >
                                                    {translate('clear')}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {s_.groupTreeInfo && s_.groupTreeInfo.total && (
                                <div className={styles.dsStatusBlock}>
                                    {(() => {
                                        const parameters = [
                                            {
                                                index: 1,
                                                component: (
                                                    <div key={'key'} className={styles.statusBlock}>
                                                        <div className={styles.statusBlockLabel}>
                                                            {translate('totalDevicesCount')}:
                                                        </div>
                                                        <div className={styles.statusBlockValue}>
                                                            {s_.groupTreeInfo.total.digitalSignagesCount}
                                                        </div>
                                                    </div>
                                                ),
                                            },
                                            {
                                                index: 0,
                                                component: (
                                                    <div key={'key'} className={styles.statusBlock}>
                                                        <div className={styles.statusBlockLabel}>
                                                            {translate('totalGroupsCount')}:
                                                        </div>
                                                        <div className={styles.statusBlockValue}>
                                                            {s_.groupTreeInfo.total.groupsCount}
                                                        </div>
                                                    </div>
                                                ),
                                            },
                                        ]

                                        return parameters
                                            .sort((item1, item2) => (item1.index > item2.index ? 1 : -1))
                                            .map((parameter) => parameter.component)
                                    })()}
                                    {s_.times && (
                                        <div className={styles.statusBlock}>
                                            <div className={styles.statusBlockLabel}>
                                                {translate('uptimeDigitalSignage')}
                                            </div>
                                            <div className={styles.statusBlockValue}>
                                                {template(translate('uptimeTime'), {
                                                    time: {
                                                        days: s_.times.diffDays,
                                                        hours: s_.times.diffTimes.split(':')[0],
                                                        minutes: s_.times.diffTimes.split(':')[1],
                                                        seconds: s_.times.diffTimes.split(':')[2],
                                                    },
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    {s_.deviceTimes && (
                                        <div className={styles.statusBlock}>
                                            <div className={styles.statusBlockLabel}>{translate('uptimeDevice')}</div>
                                            <div className={styles.statusBlockValue}>
                                                {template(translate('uptimeTime'), {
                                                    time: {
                                                        days: s_.deviceTimes.diffDays,
                                                        hours: s_.deviceTimes.diffTimes.split(':')[0],
                                                        minutes: s_.deviceTimes.diffTimes.split(':')[1],
                                                        seconds: s_.deviceTimes.diffTimes.split(':')[2],
                                                    },
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {s_.dsState && (
                                <div className={styles.dsStatusBlock}>
                                    {(() => {
                                        const dsState = { ...s_.dsState }
                                        if (dsState) {
                                            dsState.startTime = s_.startTime
                                        }

                                        const topKeys = ['cpuTemperature', 'cpuLoad', 'currentDate', 'timezone']
                                        const gridKeys = [
                                            'batteryLevel',
                                            'powerSource',
                                            'freeRAM',
                                            'startTime',
                                            'deviceStartTime',
                                        ]

                                        const renderStatusBlock = (key: string) => {
                                            if (dsState[key] === undefined) {
                                                return null
                                            }

                                            if ((key === 'deviceStartTime' || key === 'startTime') && !dsState[key]) {
                                                return null
                                            }

                                            return (
                                                <div key={key} className={styles.statusBlock}>
                                                    <div className={styles.statusBlockLabel}>
                                                        {getDsStateLabel(key)}
                                                    </div>
                                                    <div className={styles.statusBlockValue}>
                                                        {getDsStateFormat(dsState, key)}
                                                    </div>
                                                </div>
                                            )
                                        }

                                        return (
                                            <>
                                                <div className={styles.statusTopRow}>
                                                    {topKeys.map((key) => renderStatusBlock(key))}
                                                </div>
                                                <div className={styles.statusGrid}>
                                                    {gridKeys.map((key) => renderStatusBlock(key))}
                                                    {s_.times && (
                                                        <div className={styles.statusBlock}>
                                                            <div className={styles.statusBlockLabel}>
                                                                {translate('uptimeDigitalSignage')}
                                                            </div>
                                                            <div className={styles.statusBlockValue}>
                                                                {template(translate('uptimeTime'), {
                                                                    time: {
                                                                        days: s_.times.diffDays,
                                                                        hours: s_.times.diffTimes.split(':')[0],
                                                                        minutes: s_.times.diffTimes.split(':')[1],
                                                                        seconds: s_.times.diffTimes.split(':')[2],
                                                                    },
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {s_.deviceTimes && (
                                                        <div className={styles.statusBlock}>
                                                            <div className={styles.statusBlockLabel}>
                                                                {translate('uptimeDevice')}
                                                            </div>
                                                            <div className={styles.statusBlockValue}>
                                                                {template(translate('uptimeTime'), {
                                                                    time: {
                                                                        days: s_.deviceTimes.diffDays,
                                                                        hours: s_.deviceTimes.diffTimes.split(':')[0],
                                                                        minutes: s_.deviceTimes.diffTimes.split(':')[1],
                                                                        seconds: s_.deviceTimes.diffTimes.split(':')[2],
                                                                    },
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )
                                    })()}
                                </div>
                            )}
                        </div>
                        <div className={styles.rightBlock}>
                            <div className={styles.headerPanel}>
                                <div className={styles.toggleButtons}>
                                    <button
                                        className={styles.toggleViewButton}
                                        onClick={() => toggleAll(!isAllFieldsExpanded)}
                                    >
                                        <Icon type={isAllFieldsExpanded ? 'viewHide' : 'view'} size={16} />
                                        <span>
                                            {translate(isAllFieldsExpanded ? 'hideAllFields' : 'showAllFields')}
                                        </span>
                                    </button>
                                </div>
                                <div className={styles.iconGroupWrapper}>
                                    <Icon
                                        type="copyToClipboard"
                                        size={18}
                                        color={colors.blackLight}
                                        tooltip={{ html: translate('copyToClipboard') }}
                                        onClick={copyParametersToClipboard}
                                        containerClass={styles.rightBtn}
                                    />
                                    {p_.selectedInfo.online && (
                                        <Icon
                                            type="update_tiny"
                                            size={18}
                                            color={colors.blackLight}
                                            tooltip={{ html: translate('updateDsInfo') }}
                                            onClick={() => {
                                                getDsStorageInfo({ digitalSignageId: p_.selectedInfo.id })
                                                getExternalStorageInfo({
                                                    digitalSignageId: p_.selectedInfo.id,
                                                })
                                                getNetworkInfo({ id: p_.selectedInfo.id })
                                            }}
                                            containerClass={styles.rightBtn}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className={styles.paramsList}>
                                <div className={styles.scroll}>
                                    {renderGroupedParameters(
                                        { ...s_.formattedParameters },
                                        copyParameterValueToClipboard,
                                        p_.selectedInfo.status,
                                        s_,
                                        isOnline,
                                        getConnectionsSpeed,
                                        getStorageConnectionSpeed,
                                        p_.selectedInfo.activeQ,
                                        serviceRef.current,
                                        deviceRef.current,
                                        licensesRef.current,
                                        networkRef.current,
                                        storageRef.current,
                                        toggleSingle,
                                        p_.selectedInfo.type,
                                        showConnectionError
                                    )}
                                    {p_.selectedInfo.type === 'group' &&
                                        s_.groupTreeInfo &&
                                        s_.groupTreeInfo.list &&
                                        renderGroupTreeInfo(
                                            p_.selectedInfo,
                                            s_.groupTreeInfo.list,
                                            copyParameterValueToClipboard,
                                            groupTreeRef.current,
                                            toggleSingle,
                                            s_.groupsOpened,
                                            onToggleGroup
                                        )}
                                    {renderExternalStorageInfo(
                                        s_.externalStorages,
                                        p_.selectedInfo.status,
                                        copyParameterValueToClipboard,
                                        externalStorageRef.current,
                                        toggleSingle
                                    )}
                                    {getBuildInfo(
                                        s_.buildInfo,
                                        p_.selectedInfo.status,
                                        copyParameterValueToClipboard,
                                        s_.showMore,
                                        setShowMore,
                                        buildRef.current,
                                        toggleSingle
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {s_.wakeOnLanModal && (
                        <WakeOnLan
                            digitalSignageId={p_.selectedInfo.id}
                            onClose={() => {
                                setState((prevState) => {
                                    return {
                                        ...prevState,
                                        wakeOnLanModal: false,
                                    }
                                })
                            }}
                        />
                    )}
                    {s_.webEngineInfo && (
                        <div className={styles.webEngineModal}>
                            <div className={styles.webEngineModalInner}>
                                <div className={styles.webEngineModalClose} onClick={closeWebEngineInfo}>
                                    <Icon
                                        type={'close'}
                                        color={colors.greyDark}
                                        size={16}
                                        tooltip={{ title: translate('close') }}
                                    />
                                </div>
                                <Typography type={'title'}>
                                    <div className={styles.webEngineInfoCaption}>{translate('webEngineInfo')}:</div>
                                </Typography>
                                <Typography>{s_.webEngineInfo}</Typography>
                            </div>
                        </div>
                    )}
                    {s_.showClearLogsWarning && (
                        <div className={styles.confirmModal}>
                            <div className={styles.confirmModalInner}>
                                <div className={styles.confirmModalText}>{translate('clearLogsWarning')}</div>
                                <div className={styles.confirmModalButtons}>
                                    <Button
                                        type="button"
                                        mod="withBorder"
                                        className={styles.confirmModalButton}
                                        onClick={() =>
                                            setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    showClearLogsWarning: false,
                                                }
                                            })
                                        }
                                    >
                                        {translate('close')}
                                    </Button>
                                    <Button
                                        type="button"
                                        mod={'fill'}
                                        className={styles.confirmModalButton}
                                        onClick={() => {
                                            api.send('clearDigitalSignageDiskSpace', {
                                                digitalSignageId: p_.selectedInfo.id,
                                                ...s_.clean,
                                            })
                                            setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    showCleanMenu: false,
                                                    showClearLogsWarning: false,
                                                }
                                            })
                                        }}
                                    >
                                        {translate('submit')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    <ModalAccept
                        open={!!s_.openPowerModal}
                        onReject={() =>
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    openPowerModal: '',
                                }
                            })
                        }
                        onAccept={() => {
                            const data = { [s_.openPowerModal]: p_.selectedInfo.id }
                            api.send('shutdownDisplay', data)
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    openPowerModal: '',
                                }
                            })
                        }}
                        onClose={() =>
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    sleepModeModal: '',
                                }
                            })
                        }
                        description={translate(
                            s_.openPowerModal === 'groupId' ? 'powerOffWarning_' : 'powerOffWarning'
                        )}
                        rejectLabel={translate('cancel')}
                        acceptLabel={translate('off')}
                    />
                    <ModalAccept
                        open={!!s_.sleepModeModal}
                        onReject={() =>
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    sleepModeModal: '',
                                }
                            })
                        }
                        onAccept={() => {
                            const data = { [s_.sleepModeModal]: p_.selectedInfo.id }
                            enterSleepMode(data, () =>
                                setState((prevState) => {
                                    return {
                                        ...prevState,
                                        sleepModeModal: '',
                                    }
                                })
                            )
                        }}
                        onClose={() =>
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    sleepModeModal: '',
                                }
                            })
                        }
                        description={translate(
                            s_.sleepModeModal === 'groupId' ? 'sleepModeWarning_' : 'sleepModeWarning'
                        )}
                        rejectLabel={translate('cancel')}
                        acceptLabel={translate('go')}
                    />
                </div>
            </div>
        </Scrollbars>
    )
}

const mapStateToProps = (state: {
    displays: {
        isConnected: boolean
    }
    user: {
        data: {
            companyId: string
        }
    }
}) => {
    return {
        isConnected: state.displays.isConnected,
    }
}

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
        closeModal: () => dispatch(displaysActions.closeModal()),
        getClientLogs: (logsData: { id: number; actual: boolean }) => dispatch(getClientLogs(logsData)),
        setMonitorWindow: (data: ISetMonitorWindow) => dispatch(appActions.setMonitorWindow(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DisplaysInfo))
